const listeners = {}
let nextId = 0

export const subscribe = (name, fn) => {
    let [evt, id] = name.split('.')
    id = (id && id.trim()) || ('_' + (++nextId))

    let ls = listeners[evt] || (listeners[evt] = {})
    ls[id] = fn
    return evt + '.' + id
}

export const publish = (evt, ...args) => {
    let ls = listeners[evt]
    return ls
        && Object.values(ls).map( (fn) => fn.call(null, ...args))
}

export const unsubscribe = (name) => {
    let [evt, id] = name.split('.')

    let ls = listeners[evt]
    return ls && (delete ls[id])
}

export const execute = (name, ...args) => {
    let [evt, id] = name.split('.')
    let ls = listeners[evt]
    let fn = ls && ls[id]
    return fn ? fn.call(null, ...args) : undefined
}

export const assignProperties = (obj, ...args) => args.reduce( (x, a) => Object.defineProperties(x, Object.getOwnPropertyDescriptors(a)), obj)

export const define = (ns, value, root = window) => {
    const a = ns.split(".").reduce((curr, n) => {
        if (!(n in curr)) curr[n] = {}
        return curr[n]
    }, root) || {}
    return assignProperties(a, value)
}

export const ProxyContext = {
    proxies: {},
    id: 0,
    build(id, target, context) {
        return new Proxy(target, {
            id,
            context,
            get(obj, prop) {
                if (prop!=='_destroyed' && this.destroyed) return 
                if (prop.startsWith("_")) return this[prop.substring(1)]

                const fo = Reflect.get(obj, prop)
                const fc = context[prop]
                return typeof fo === 'function' ? (...args) => fo.apply(obj, [context, ...args])
                    : fo !== undefined ? fo
                    : typeof fc === 'function'  ? (...args) => fc.apply(context, [...args])
                    : fc
            },
            set(obj, prop, value) {
                if (prop.startsWith("_")) {
                    this[prop.substring(1)] = value
                    return true
                } else {
                    return Reflect.set(obj, prop, value)
                }
            },
            destroy: () => this.destroy(id),
        })
    },
    init(target, context,id="") {
        id = id || `proxy-context-${++this.id}`
        this.destroy(id)
        const p = this.build(id, target, context)
        this.proxies[id] = p
        return p
    },
    get(id) {
        return this.proxies[id]
    },
    destroy(id) {
        const p = this.proxies[id]
        if (p) { p._destroyed = true }
        delete this.proxies[id]
    }
}

export const proxyContext = (target, context, id="") => ProxyContext.init(target, context, id)




// WEBPACK FOOTER //
// ./src/twd/pubsub.js